"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeBannerItemsSelector = exports.makeSelectMissingBannerZoneIds = exports.makeTournamentByZoneId = exports.makeSelectBannerIdByAttributes = exports.makeBannerZonesAvailabilitySelector = exports.makeAttributesByBannerZoneSelector = exports.makeSelectBannerZonesByAttributes = exports.makeSelectBannerByZoneId = exports.makeBannerZoneAvailabilitySelector = exports.makeBannerZoneSettingsSelector = exports.makeBannerZoneSelector = exports.selectBannerZonesFetchStatus = exports.selectAvailableBannerZones = exports.selectZoneBanners = exports.selectCmsBanners = exports.selectBannersState = void 0;
var core_1 = __importStar(require("@gin-betting/core"));
var constants_1 = require("@gin-betting/constants");
var reselect_1 = require("reselect");
var lodash_1 = require("lodash");
var constants_2 = require("./constants");
var isMobile = core_1.default.constants.isMobile, _a = core_1.default.entities.selectors, selectTournaments = _a.selectTournaments, selectSportTypeBySports = _a.selectSportTypeBySports;
var selectBannersState = function (state) { return state.get(constants_2.NAME); };
exports.selectBannersState = selectBannersState;
exports.selectCmsBanners = reselect_1.createSelector(exports.selectBannersState, function (bannersState) { return bannersState.get('cmsBanners'); });
exports.selectZoneBanners = reselect_1.createSelector(exports.selectBannersState, exports.selectCmsBanners, function (bannersState, cmsBanners) {
    var existedCmsBannerIds = cmsBanners.map(function (_a) {
        var id = _a.id;
        return id;
    });
    return bannersState.get('zoneBanners').map(function (banner) {
        return banner.set('config', banner.config.filter(function (_a) {
            var type = _a.type, id = _a.id;
            return type !== core_1.API.BannerType.cms_banner ||
                lodash_1.includes(existedCmsBannerIds, id);
        }));
    });
});
exports.selectAvailableBannerZones = reselect_1.createSelector(exports.selectBannersState, function (bannersState) { return bannersState.get('availableZones'); });
exports.selectBannerZonesFetchStatus = reselect_1.createSelector(exports.selectBannersState, function (bannersState) { return bannersState.get('fetchStatus'); });
var makeBannerZoneSelector = function (zoneId) {
    return reselect_1.createSelector(exports.selectAvailableBannerZones, function (bannerZones) {
        return bannerZones.find(function (zone) { return zone.id === zoneId; });
    });
};
exports.makeBannerZoneSelector = makeBannerZoneSelector;
var makeBannerZoneSettingsSelector = function (zoneId) {
    return reselect_1.createSelector(exports.makeBannerZoneSelector(zoneId), function (bannerZone) {
        return bannerZone === null || bannerZone === void 0 ? void 0 : bannerZone.settings;
    });
};
exports.makeBannerZoneSettingsSelector = makeBannerZoneSettingsSelector;
var makeBannerZoneAvailabilitySelector = function (zoneId) {
    return reselect_1.createSelector(exports.makeBannerZoneSelector(zoneId), function (bannerZone) {
        return !!bannerZone;
    });
};
exports.makeBannerZoneAvailabilitySelector = makeBannerZoneAvailabilitySelector;
var makeSelectBannerByZoneId = function (zoneId) {
    return reselect_1.createSelector(exports.selectZoneBanners, function (bannerZone) {
        return bannerZone.get(zoneId);
    });
};
exports.makeSelectBannerByZoneId = makeSelectBannerByZoneId;
var makeSelectBannerZonesByAttributes = function (attributes) {
    var platform = isMobile
        ? constants_1.BannerZonePlatform.MOBILE
        : constants_1.BannerZonePlatform.DESKTOP;
    return reselect_1.createSelector(exports.selectAvailableBannerZones, selectSportTypeBySports, function (bannerZones, pageType) {
        var transformedAttributes = attributes.map(function (attrs) { return (__assign({ pageType: pageType,
            platform: platform }, attrs)); });
        return lodash_1.flatten(transformedAttributes.map(function (attrs) {
            return getBannerZoneByAttributes(bannerZones, attrs);
        }));
    });
};
exports.makeSelectBannerZonesByAttributes = makeSelectBannerZonesByAttributes;
var makeAttributesByBannerZoneSelector = function (zoneId) {
    return reselect_1.createSelector(exports.selectAvailableBannerZones, function (bannerZones) {
        var bannerZone = bannerZones.find(function (_a) {
            var id = _a.id;
            return id === zoneId;
        });
        return bannerZone === null || bannerZone === void 0 ? void 0 : bannerZone.attributes;
    });
};
exports.makeAttributesByBannerZoneSelector = makeAttributesByBannerZoneSelector;
var makeBannerZonesAvailabilitySelector = function (attributes) {
    return reselect_1.createSelector(exports.makeSelectBannerZonesByAttributes(attributes), function (bannerZones) { return !lodash_1.isEmpty(bannerZones); });
};
exports.makeBannerZonesAvailabilitySelector = makeBannerZonesAvailabilitySelector;
var makeSelectBannerIdByAttributes = function (attributes) {
    return reselect_1.createSelector(exports.selectAvailableBannerZones, function (bannerZones) { var _a; return (_a = getBannerZoneByAttributes(bannerZones, attributes)[0]) === null || _a === void 0 ? void 0 : _a.id; });
};
exports.makeSelectBannerIdByAttributes = makeSelectBannerIdByAttributes;
var makeTournamentByZoneId = function (zoneId) {
    return reselect_1.createSelector(exports.makeSelectBannerByZoneId(zoneId), selectTournaments, function (banner, tournaments) {
        if (!banner) {
            return;
        }
        var config = banner.config;
        var tournament = config.find(function (bannerConfig) {
            var type = bannerConfig.type;
            return type === core_1.API.BannerType.betting_tournament;
        });
        if (tournament) {
            var tournamentId = tournament.id;
            return tournaments.get(tournamentId);
        }
    });
};
exports.makeTournamentByZoneId = makeTournamentByZoneId;
var makeSelectMissingBannerZoneIds = function (zoneIds) {
    var bannerZoneSelectors = zoneIds.map(function (zoneId) {
        return exports.makeSelectBannerByZoneId(zoneId);
    });
    // NOTE: "createSelector" type issue with rest args
    return reselect_1.createSelector.apply(void 0, __spreadArray(__spreadArray([], bannerZoneSelectors), [function () {
            var bannerZonesArr = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                bannerZonesArr[_i] = arguments[_i];
            }
            return (
            // NOTE: bannerZonesArr.length should be equal with zoneIds.length for correct filtration missingZoneIds
            bannerZonesArr
                // NOTE: ZoneId should be omitted if banner is existed
                .map(function (banner, idx) { return (banner ? undefined : zoneIds[idx]); })
                .filter(function (zoneId) { return !!zoneId; }));
        }]));
};
exports.makeSelectMissingBannerZoneIds = makeSelectMissingBannerZoneIds;
var makeBannerItemsSelector = function (zoneId, bannerItemType, selectBannerZoneById) {
    if (selectBannerZoneById === void 0) { selectBannerZoneById = exports.makeSelectBannerByZoneId(zoneId); }
    return reselect_1.createSelector(selectBannerZoneById, function (banner) {
        if (!banner) {
            return [];
        }
        return banner.config.filter(function (b) { return bannerItemType === b.type; });
    });
};
exports.makeBannerItemsSelector = makeBannerItemsSelector;
function getBannerZoneByAttributes(bannerZones, identityAttr) {
    // NOTE: remove nullable props
    var attr = lodash_1.pickBy(identityAttr, function (value) { return !lodash_1.isUndefined(value); });
    return bannerZones
        .filter(function (_a) {
        var attributes = _a.attributes;
        return lodash_1.isEqual(lodash_1.pick(attributes, lodash_1.keys(attr)), attr);
    })
        .toArray();
}
//# sourceMappingURL=selectors.js.map